module.exports = __webpack_public_path__ + "img/banner-soft.34e87114.png";